import { useState, useEffect, ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

interface ErrorBoundaryProps {
  children: ReactNode;
}

export default function ErrorBoundary(props: ErrorBoundaryProps) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    function handleError() {
      setHasError(true);
    }

    window.addEventListener("error", handleError);

    return () => {
      window.removeEventListener("error", handleError);
    };
  }, []);

  if (hasError) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          textAlign: 'center',
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: '20px',
          borderRadius: '8px',
        }}
      >
        <ErrorIcon sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          Erreur : Quelque chose ne va pas !
        </Typography>
        <Typography variant="body1">
          Nous rencontrons actuellement des problèmes. Veuillez réessayer plus tard.
        </Typography>
      </Box>
    );
  }

  return <>{props.children}</>;
}
